import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { SharedDataService } from '../../services/shared-data.service';


@Component({
  selector: 'app-upload-button',
  templateUrl: './upload-button.component.html',
  styleUrls: ['./upload-button.component.scss']
})

export class UploadButtonComponent implements OnInit {

  @Output() openUpload = new EventEmitter<void>();

  private progress = 0;

  get isActiveUpload() {
    return this.progress > 0 && this.progress < 100;
  }

  get progressPercentage() {
    return `${this.progress}%`
  }

  constructor(
    public sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.sharedDataService.uploadProgressObservable.subscribe(
      value => this.progress = value
    );
  }

  public handleOpenDialog(): void {
    this.openUpload.emit()
  }

}
